import Footer from "./components/Footer";
import Header from "./components/Header";
import Main from "./components/Main";

function App() {
    return (
        <div className="min-h-screen bg-[#121212] text-gray-100">
            <Header />
            <div className="container mx-auto px-4 py-6 max-w-6xl">
                <Main />
            </div>
            <Footer />
        </div>
    );
}

export default App;
